import styled from 'styled-components'


export const Imagefigure = styled.figure`
    width: 400px;
    height: 60px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    color: #000000;
    user-select: none;
`;

export const ImageLogo = styled.img`
    width: 160px;
    height: 90px;
    box-sizing: border-box;
`;

export const MV3Figure = styled.figure`
    width: 400px;
    height: 60px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 1.0em;
    color: #000000;
    user-select: none;
`;

export const MV3img = styled.img`
    width: 94px;
    height: 40px;
`;